import React from 'react';

const NotFound: React.FC = () => {
  return (
    <div className="search-firm search-firm__not-found">
      Sorry, no matches found. This could be due to one of the following:
      <ul>
        <li>Incorrect details provided</li>
        <li>Your firm is not registered</li>
        <li>Your firm is not active</li>
      </ul>
    </div>
  );
};

export default NotFound;
